import { Component, Inject, OnInit, Optional } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ProfileComponent } from '../profile.component';

@Component({
  selector: 'app-edit-password',
  templateUrl: './edit-password.component.html',
  styleUrls: ['./edit-password.component.css']
})
export class EditPasswordComponent implements OnInit {

  adminEmail;
  admin: any;

  constructor(
    private authService: AuthService,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<ProfileComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService
  ) {
    this.adminEmail = data.adminEmail;
  }

  ngOnInit(): void {
    this.authService.adminDetails({ email: this.adminEmail }).subscribe((res: any) => {
      this.admin = res.data;
    });
  }

  onSubmit(form: NgForm) {
    this.spinner.show();
    const params = {
      email: this.admin.email,
      newPassword: form.value.password
    };

    this.authService.editAdminPassword(params).subscribe((res: any) => {
      this.spinner.hide();
      if (res.status) {
        this.toast.success(res.message, "Successs", {
          timeOut: 2500,
          progressBar: true,
          progressAnimation: 'increasing',
          positionClass: 'toast-top-right'
        });

        this.closeModel();
      } else {
        this.toast.error("Details not updated....error occured", "Error", {
          timeOut: 2500,
          progressBar: true,
          progressAnimation: 'increasing',
          positionClass: 'toast-top-right'
        })
      }
    })

  }

  closeModel() {
    this.dialogRef.close();
    this.authService.filter("Deleted");
  }

}
